import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { SendEmail } from "../../api/smtpEmailService";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ContactUsSection = () => {
    document.title = "Contact Us";

    const [fbTooltip, setFbTooltip] = useState(false);
    const [twTooltip, setTwTooltip] = useState(false);
    const [igTooltip, setIgTooltip] = useState(false);
    const [lnTooltip, setLnTooltip] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const result = await SendEmail(formData);

            if (result.Success) {
                toast.success(result.Message, {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 3000
                });
                setFormData({ name: "", email: "", subject: "", message: "" });
            } else {
                toast.error("Failed to send message.", {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 3000
                });
            }
        } catch (error) {
            toast.error("Something went wrong!", {
                theme: "colored",
                position: "top-right",
                autoClose: 3000
            });
        }


        setLoading(false);
    };

    return (
        <div className="contact-section py-5 overflow-hidden">
            <div className="container">
                <div className="row align-items-start">

                    <div className="col-lg-6 mb-5 mb-lg-0" data-aos="fade-in">
                        <h2 className="contact-title mb-4">
                            We are always ready <br /> to help you and <br /> answer your questions
                        </h2>
                        <p className="contact-desc mb-5">
                            We value your inquiries connect with us for
                            guidance, support, and personalized assistance today.
                        </p>

                        <div className="row gy-4 gx-5">

                            <div className="row">
                                {/* Left Column: Addresses */}
                                <div className="col-md-6">
                                    <div className="our-location">
                                        <h3 className="contact-heading">Our Locations</h3>

                                        <h6 className="fw-bold text-muted">Head Office - Mumbai</h6>
                                        <a
                                            href="https://www.google.com/maps/place/Meera+Jewellery+House+LLP/@19.1229392,72.8629935,17z/data=!4m14!1m7!3m6!1s0x3be7c9538da64c97:0x45bc978da687e00f!2sMeera+Jewellery+House+LLP!8m2!3d19.1229291!4d72.8630042!16s%2Fg%2F11x_832cbg!3m5!1s0x3be7c9538da64c97:0x45bc978da687e00f!8m2!3d19.1229291!4d72.8630042!16s%2Fg%2F11x_832cbg?entry=ttu&g_ep=EgoyMDI1MTAyOS4yIKXMDSoASAFQAw%3D%3D"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-dark text-decoration-none"
                                        >
                                            <p className="mb-1">2th Floor, Brahams Bussiness Center,</p>
                                            <p className="mb-0">Off Mahakali Caves Road, Andheri east,</p>
                                            <p className="mb-3">Mumbai, Maharastra - 400093</p>
                                        </a>

                                        <h6 className="fw-bold text-muted">Factory - Surat</h6>
                                        <a
                                            href="https://www.google.com/maps?q=3rd+Floor,+Plot+No.+10,+Near+Hira+Nagar,+Ashwini+Kumar+Road,+Varachha,+Surat,+Gujarat+395008"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-dark text-decoration-none"
                                        >
                                            <p className="mb-1">3rd Floor, Plot No. 10, Near Hira Nagar,</p>
                                            <p className="mb-0">Ashwini Kumar Road, Varachha,</p>
                                            <p className="mb-3">Surat, Gujarat – 395008</p>
                                        </a>

                                        <h6 className="fw-bold text-muted">Branch - Delhi</h6>
                                        <a
                                            href="https://www.google.com/maps?q=2448/10,+3rd+Floor,+Street+No.+10,+Gurudwara+Road,+Karol+Bagh,+Delhi+110005"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-dark text-decoration-none"
                                        >
                                            <p className="mb-1">2448/10, 3rd Floor, Street No. 10,</p>
                                            <p className="mb-0">Gurudwara Road, Opp. HDFC Bank,</p>
                                            <p className="mb-3">Karol Bagh, Delhi – 110005, India</p>
                                        </a>

                                        <h6 className="fw-bold text-muted">Midamas LLC</h6>
                                        <a
                                            href="https://www.google.com/maps?q=64+W+48th+St+%231408,+New+York,+NY+10036,+United+States"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-dark text-decoration-none"
                                        >
                                            <p className="mb-1">64 W 48th St #1408,</p>
                                            <p className="mb-0">New York, NY 10036, United States</p>
                                        </a>
                                    </div>
                                </div>

                                {/* Right Column: Contact Info */}
                                <div className="col-md-6">
                                    {/* Call Center */}
                                    <div className="contactus-right">
                                        <h5 className="contact-heading">Call Center</h5>
                                        <p className="mb-1">
                                            <a href="tel:+912261680000" className="text-dark text-decoration-none">
                                                +91-22-6168 0000
                                            </a>
                                        </p>
                                        <p>
                                            <a href="tel:+912261815353" className="text-dark text-decoration-none">
                                                +91-22-6181 5353
                                            </a>
                                        </p>
                                    </div>

                                    {/* Email */}
                                    <div className="contactus-right">
                                        <h5 className="contact-heading">Email</h5>
                                        <p>
                                            <a
                                                href="mailto:enquiries@meerajewellery.net"
                                                className="text-dark text-decoration-none"
                                            >
                                                enquiries@meerajewellery.net
                                            </a>
                                        </p>
                                    </div>
                                <div className="col-6 contactus-right">
                                    <h5 className="contact-heading">Social network</h5>
                                    <div className="social-links d-flex">
                                        <a href="#" id="fbIcon" onClick={(e) => e.preventDefault()}>
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                        <Tooltip
                                            placement="bottom"
                                            isOpen={fbTooltip}
                                            target="fbIcon"
                                            toggle={() => setFbTooltip(!fbTooltip)}
                                        >
                                            Available Soon
                                        </Tooltip>

                                        <a href="#" id="twIcon" onClick={(e) => e.preventDefault()}>
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                        <Tooltip
                                            placement="bottom"
                                            isOpen={twTooltip}
                                            target="twIcon"
                                            toggle={() => setTwTooltip(!twTooltip)}
                                        >
                                            Available Soon
                                        </Tooltip>

                                        <a
                                            href="https://www.instagram.com/meera_jewelleryhouse/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            id="igIcon"
                                        >
                                            <i className="fab fa-instagram"></i>
                                        </a>

                                        <a
                                            href="https://www.linkedin.com/company/meera-jewellery-house-llp"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            id="lnIcon"
                                        >
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>

                                    </div>
                                </div>
                                </div>

                            </div>


                        </div>
                    </div>

                    <div className="col-lg-6" data-aos="fade-in">
                        <div className="contact-form-card p-4 p-md-5 rounded-4 shadow-sm bg-light">
                            <h3 className="form-title mb-2">Get in Touch</h3>
                            <p className="form-desc mb-4">
                                Define your goals and identify areas where AI can add value to your business
                            </p>
                            <form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Full name"
                                    className="form-input"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    className="form-input"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                <input
                                    type="text"
                                    name="subject"
                                    placeholder="Subject"
                                    className="form-input"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                />
                                <textarea
                                    name="message"
                                    placeholder="Message"
                                    rows="3"
                                    className="form-input"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>

                                <button
                                    type="submit"
                                    className="form-btn d-inline-flex align-items-center gap-2 mt-3"
                                    disabled={loading}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    {loading ? "Sending..." : "Send a message"}
                                </button>
                            </form>
                        </div>
                        {/* Toast Container */}
                        <ToastContainer position="top-right" newestOnTop />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ContactUsSection;
